import { useSelector } from "react-redux"

import { useVampHistoricalDataMode } from "./useHistoricalDataMode"

export const useVampDataAvailable = () => {
  const { enrollmentData } = useSelector((state) => state.health)
  const isVampAvailable = enrollmentData?.is_vamp_available
  const isHistoricalDataAvailable = enrollmentData?.historical_data_available
  const { isHistoricalDataMode } = useVampHistoricalDataMode()
  return isVampAvailable || (isHistoricalDataMode && isHistoricalDataAvailable)
}
